module.exports = __webpack_public_path__ + "329934d53a20210120a117de0de9938f.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/manual/System-Manual-v2.0.pdf
// module id = 9xmx
// module chunks = 1